module.exports = __webpack_public_path__ + "img/preferences.b51b9542.png";